module.exports = __webpack_public_path__ + "img/hfbank.c0724abc.png";